<app-translation-field-editor
  [value]="translationValue"
  [disabled]="isReadonly"
  [multiLine]="multiLine"
  (valueChange)="writeTranslations($event)">
</app-translation-field-editor>
<ng-template #fieldComponent></ng-template>
